import Vue from 'vue'
import VAChart from 'vue-apexcharts'

Vue.use(VAChart)

Vue.component('apexchart', VAChart)
